import React from "react";
import { FaSpinner } from "react-icons/fa";
import PropTypes from "prop-types";
import styled from "styled-components";

export const Loader = styled.div`
  display: ${(p) => (p.fullPage ? "flex" : "inline-block")};
  ${(p) =>
    p.fullPage
      ? `
    align-items: center;
    justify-content: center;
    height: calc(100vh - 4rem);
    > * {
      font-size: 24px;
    }
  `
      : ""}
  div {
    margin-right: 10px;
    position: relative;
    top: 2px;
  }
  > svg {
    animation: fa-spin 2s infinite linear;
  }

  @keyframes fa-spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(359deg);
    }
  }
`;

export default function Loading({ fullPage = false, text }) {
  return (
    <Loader fullPage={fullPage}>
      {text && <div>{text}</div>}
      <FaSpinner />
    </Loader>
  );
}

Loading.propTypes = {
  fullPage: PropTypes.bool,
  text: PropTypes.string,
};
